import { render, staticRenderFns } from "./BooleanSelectEditor.vue?vue&type=template&id=63082347&"
import script from "./BooleanSelectEditor.vue?vue&type=script&lang=ts&"
export * from "./BooleanSelectEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports